import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AlertTriangle } from "lucide-react";
import { api } from "@/lib/api";
import { fmtDate, rupiah, todayStr } from "@/lib/format";

const daysTo = (d) => Math.round((new Date(`${d}T00:00:00`) - new Date(`${todayStr()}T00:00:00`)) / 86400000);

export const DueReminder = () => {
  const [inv, setInv] = useState([]);
  useEffect(() => { api.get("/billing/my").then((r) => setInv(r.data.invoices.filter((i) => i.status !== "lunas" && daysTo(i.due_date) <= 3))).catch(() => {}); }, []);
  if (!inv.length) return null;
  return (
    <div className="mb-6 space-y-2" data-testid="due-reminder">
      {inv.map((i) => {
        const n = daysTo(i.due_date);
        const late = n < 0;
        return (
          <Link key={i.id} to="/tagihan-wilayah" className={`flex items-start gap-3 rounded-2xl border px-4 py-3 text-sm ${late ? "border-rose-300 bg-rose-500/10" : "border-amber-300 bg-amber-500/10"}`} data-testid={`due-reminder-${i.id}`}>
            <AlertTriangle className={`h-5 w-5 shrink-0 ${late ? "text-rose-600" : "text-amber-600"}`} />
            <span>
              <b>Tagihan layanan {rupiah(i.amount)}</b> {late ? `sudah lewat jatuh tempo (${fmtDate(i.due_date)}). Kantor cabang dinonaktifkan sampai tagihan lunas.` : n === 0 ? "jatuh tempo hari ini." : `jatuh tempo ${n} hari lagi (${fmtDate(i.due_date)}).`}
              {i.status === "menunggu" ? " Bukti bayar sedang diperiksa." : " Segera bayar dan kirim bukti pembayaran."}
            </span>
          </Link>
        );
      })}
    </div>
  );
};
